import { WhitelistAddressFormType, WhitelistConfigType } from 'data/Form/WhitelistAddress/types'
import { WithdrawalResponse } from 'data/Form/Withdrawal/types'
import { CurrencyDefinitionType } from 'data/Instrument/types'
import { AccountType, BeneficiaryType, PaymentMethodType } from 'data/Payments/types'
import fetchApi from 'utils/fetchApi'
import { getApiUrl } from 'utils/urlBuilder'

export const getWhitelistInfo = () =>
  fetchApi<WhitelistConfigType>({
    auth: true,
    method: 'GET',
    url: getApiUrl('nabu-gateway/payments/whitelist')
  })

export const getBeneficiaries = () =>
  fetchApi<BeneficiaryType>({
    auth: true,
    method: 'GET',
    url: getApiUrl('nabu-gateway/payments/beneficiaries')
  })

export const getCurrencies = () =>
  fetchApi<CurrencyDefinitionType[]>({
    auth: true,
    method: 'GET',
    url: getApiUrl('nabu-gateway/payments/currencies')
  })

export const createAccount = (currency: string) =>
  fetchApi<AccountType>({
    auth: true,
    body: {
      currency
    },
    method: 'PUT',
    url: getApiUrl('nabu-gateway/payments/accounts/pit')
  })

export const addWhitelistAddress = (body: WhitelistAddressFormType) =>
  fetchApi<void>({
    auth: true,
    body: {
      address: body.address,
      challengeId: body.challengeId,
      code: body.code,
      currency: body.currency,
      name: body.name
    },
    method: 'POST',
    url: getApiUrl('nabu-gateway/payments/whitelist')
  })

export const removeBeneficiary = (id) =>
  fetchApi<void>({
    method: 'DELETE',
    url: getApiUrl(`nabu-gateway/payments/beneficiaries/${id}`)
  })

type RemoveWhitelistAddressRequest = {
  challengeId?: string
  code: string
  id: string
}
export const removeWhitelistAddress = ({ challengeId, code, id }: RemoveWhitelistAddressRequest) =>
  fetchApi<void>({
    auth: true,
    body: { challengeId, code },
    method: 'DELETE',
    url: getApiUrl(`nabu-gateway/payments/whitelist/${id}`)
  })

type DisableWhitelistAddressRequest = {
  challengeId?: string
  code?: string
}
export const disableWhitelist = ({ challengeId, code }: DisableWhitelistAddressRequest) =>
  fetchApi<WhitelistConfigType>({
    auth: true,
    body: { challengeId, code },
    method: 'DELETE',
    url: getApiUrl('nabu-gateway/payments/whitelist')
  })

export const getTransactions = (url: string) =>
  fetchApi({
    auth: true,
    method: 'GET',
    url: getApiUrl(`nabu-gateway/${url}`)
  })

export const withdraw = (body) =>
  fetchApi<WithdrawalResponse>({
    auth: true,
    body,
    method: 'POST',
    url: getApiUrl('nabu-gateway/payments/withdrawals')
  })

export const getWithdrawalMinsAndFees = (paymentMethod) => {
  const query = paymentMethod
    ? `product=MERCURY&paymentMethod=${paymentMethod}`
    : 'product=MERCURY&paymentMethod=DEFAULT'
  return fetchApi<string>({
    auth: true,
    method: 'GET',
    url: getApiUrl(`nabu-gateway/payments/withdrawals/fees?${query}`)
  })
}

type PaymentMethodResponseType = {
  methods: Array<PaymentMethodType>
}
export const getPaymentMethods = (currency: string) =>
  fetchApi<PaymentMethodResponseType>({
    auth: true,
    method: 'GET',
    url: getApiUrl(`nabu-gateway/payments/methods?currency=${currency}&eligibleOnly=true`)
  })

export const getPayment = (id: string) =>
  fetchApi({
    auth: true,
    method: 'GET',
    url: getApiUrl(`nabu-gateway/payments/payment/${id}`)
  })
